import { getEnv } from 'services/apiEnv.service';
import { get, post } from 'services/request.service';
import {
  SubmitTeamDashboardQueryPayload,
  TeamDashboardFilterEnums,
  TeamDashboardQueryResponse
} from './team-dashboard.types';

const BASE_URL = `${getEnv('IT_BASE_URL')}/team-dashboard-management`;

export const getTeamDashboardFilterEnums = async (): Promise<TeamDashboardFilterEnums> => {
  return (await get({ url: `${BASE_URL}/overview-filter-enums` })).data;
};

export const submitTeamDashboardQuery = async (
  data: SubmitTeamDashboardQueryPayload
): Promise<TeamDashboardQueryResponse> => {
  return (await post({ url: `${BASE_URL}/overview`, data })).data;
};
